import { ErrorType } from './types';

export class ValidationError extends Error {
    constructor(public errorsPerFieldName: Record<string, ErrorType[]>) {
        super(
            `${Object.keys(errorsPerFieldName).length} field(s) have validation errors:
            ${JSON.stringify(errorsPerFieldName)}`,
        );
    }
}

export class UnableToParseValue extends Error {
    constructor(public notParsableValue: unknown) {
        super(`Could not parse value ${JSON.stringify(notParsableValue)}`);
    }
}
